import config from "./config.json";

var cfg = {
    get: function (key, defaultValue) {
        return config[key] !== undefined ? config[key] : defaultValue;
    },
};

export default cfg;
